module.exports = __webpack_public_path__ + "static/media/weed.c0baf11d.jpg";